export default "__VITE_ASSET__kuiOTqwZ__"